"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_virtualized_1 = require("react-virtualized");
exports.default = (function (rowRenderer) {
    if (!rowRenderer)
        return react_virtualized_1.defaultTableRowRenderer;
    var CustomRowRenderer = function (props) {
        var customRow = rowRenderer(props);
        if (!customRow)
            return (0, react_virtualized_1.defaultTableRowRenderer)(props);
        return (0, react_virtualized_1.defaultTableRowRenderer)(__assign(__assign({}, props), { columns: customRow }));
    };
    return CustomRowRenderer;
});
